import classNames from 'classnames'
import { SceneIcon } from '@/atoms/Icons/SceneIcon'
import { Image } from '@/atoms/Image'
import { CaptionLG, CaptionSM } from '@/atoms/Text'
import {
  AvailableMoment,
  useCollectiblesPurchaseContext,
} from '@/contexts/CollectiblesPurchaseContext/CollectiblesPurchaseContextProvider'
import { formatPrice } from '@/services/PriceFormatter'
import { CollectibleOffer, CollectibleProductInput, CollectibleProductPack } from '@/types/codegen-federation'
import { getIsGoldenScene } from '@/views/CollectiblesCheckoutView/CollectiblesSideCart/CollectiblesSideCart'

interface Props {
  moments: AvailableMoment[] | undefined
}

export const MomentsPurchaseDescription: React.FC<Props> = ({ moments }) => {
  const { cartItems } = useCollectiblesPurchaseContext()

  const getProductPrice = (offer: CollectibleOffer) => {
    const productId = offer?.products?.[0]?.id
    const cartItem = cartItems.find((item) => item.offerId === offer?.id)
    let matchingProduct = cartItem?.products?.find((p) => (p as CollectibleProductInput)?.productId === productId)
    return (matchingProduct as CollectibleProductPack)?.price
  }

  if (!moments) return

  return (
    <div className="max-h-[500px] overflow-y-auto">
      {moments.map((moment, index) => {
        const isGoldenScene = getIsGoldenScene(moment.type)
        const price = getProductPrice(moment.defaultOffer ?? '') ?? 0

        return (
          <div key={index} className="relative mt-5 flex flex-row gap-3 text-left">
            <div className="min-w-[160px] w-40 lg:min-w-[240px] lg:w-60">
              <div className="aspect-h-8 aspect-w-16 relative my-1">
                <Image
                  src={moment.thumbnail}
                  alt={moment.title || 'Moment frame'}
                  fill={true}
                  className={classNames('rounded-xl cursor-pointer outline-4 outline-transparent object-cover z-0')}
                />
              </div>
            </div>
            <div className="flex justify-evenly flex-col">
              <div className="flex justify-between">
                <div
                  className={classNames(isGoldenScene ? 'text-warm-03' : 'text-secondary-cool', 'flex items-center')}
                >
                  <SceneIcon size={24} color2={isGoldenScene ? 'warm-03' : 'secondary-cool'} />
                  <CaptionSM className="ml-2 capitalize">{isGoldenScene ? 'Golden' : 'Collectible'} scene</CaptionSM>
                </div>
              </div>
              <CaptionLG className="text-base font-[600]">{moment.title}</CaptionLG>
              <CaptionLG className="text-base font-[600]">
                {formatPrice(price, { currency: 'USD', ignoreEmptyDecimal: true })}
              </CaptionLG>
            </div>
          </div>
        )
      })}
    </div>
  )
}
